import { render, staticRenderFns } from "./AddReceiptsToReturnConsignment.vue?vue&type=template&id=8477d416"
import script from "./AddReceiptsToReturnConsignment.vue?vue&type=script&lang=js"
export * from "./AddReceiptsToReturnConsignment.vue?vue&type=script&lang=js"
import style0 from "./AddReceiptsToReturnConsignment.vue?vue&type=style&index=0&id=8477d416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports